module.exports = __webpack_public_path__ + "static/media/no_ideas.7e16a143.png";